import { render, staticRenderFns } from "./mortgage-rate-table-tabbed.vue?vue&type=template&id=7b2e8044"
import script from "./mortgage-rate-table-tabbed.vue?vue&type=script&lang=js"
export * from "./mortgage-rate-table-tabbed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports